// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1___4a35828ab5da2c8a328","cls2":"MultiPaperNewsStory-cls2__b3c641dbca791252acea MultiPaperNewsStory-cls1___4a35828ab5da2c8a328"};